export default __webpack_public_path__ + "static/media/Collection_Disable.5b7cb56c.svg";